import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@/assets/css/styles.scss";

import moment from "moment";
import axios from "axios";
import { tokenHelper } from "@/helpers/authHelper.js";
import { alertHelper } from "@/helpers/alertHelper.js";

Vue.config.productionTip = false;

var baseURL = "https://azx5a2ukn0.execute-api.us-west-2.amazonaws.com/staging";
axios.defaults.baseURL = baseURL;
axios.defaults.headers["Content-Type"] = "application/json";

new Vue({
  router,
  vuetify,
  data: {
    admin: null,
    baseURL: baseURL,
    menuActive: "",
    notifsuccess: false,
    notifdanger: false,
    textNotif: "",
    userData: "",
  },
  methods: {
    date(val) {
      return moment(new Date(val)).format("DD MMM YYYY");
    },
    dateTime(val) {
      return moment(new Date(val)).format("DD MMM YYYY - hh:mm");
    },
    alert(msg, alert) {
      alertHelper(this, msg, alert);
    },
    token(key) {
      return tokenHelper(key);
    },

    axios: axios,
    upload: function (method, url, form) {
      return this.axios({
        method: method,
        url: url,
        data: form,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
  },
  created() {
    axios.defaults.headers["Authorization"] = `Bearer ${this.token()}`;
  },
  render: (h) => h(App),
}).$mount("#app");
